<div class="store" (click)="onClick()">
  <div class="store__icon">
    <img class="image image--responsive" src="/assets/theme/logo-brandmark.png" />
  </div>
  <div class="store__text">
    nMB Online.
  </div>
</div>
